const KM_INCLUDED_PERIOD_LITERALS = {
  FULL_COMMITMENT: 'COMMON.PERIOD.FULL_COMMITMENT',
  MONTHLY: 'COMMON.UNIT_KMS_MONTH',
  YEARLY: 'COMMON.UNIT_KMS_YEAR'
}

const matchesKmAllowance = ({kmIncluded, kmIncludedPeriod}, kmAllowance) =>
  kmIncluded === kmAllowance.kmIncluded && kmIncludedPeriod === kmAllowance.kmIncludedPeriod

// A monthlyPrice of 0 means "not priced", so it always loses against a real price
const getCheapestOption = options =>
  options.reduce((cheapest, option) =>
    cheapest.monthlyPrice === 0 || cheapest.monthlyPrice > option.monthlyPrice ? option : cheapest
  )

export const getCommitmentMonths = subscriptionPriceOptions =>
  Array.from(new Set(subscriptionPriceOptions.map(({totalMonths}) => totalMonths))).sort((a, b) => a - b)

export const getKmAllowances = subscriptionPriceOptions =>
  subscriptionPriceOptions.reduce((kmAllowances, {kmIncluded, kmIncludedPeriod}) => {
    const kmAllowance = {kmIncluded, kmIncludedPeriod}

    return kmAllowances.some(added => matchesKmAllowance(added, kmAllowance))
      ? kmAllowances
      : [...kmAllowances, kmAllowance]
  }, [])

export const getKmAllowanceKey = ({kmIncluded, kmIncludedPeriod}) => `${kmIncluded}-${kmIncludedPeriod}`

export const getMatchingOptions = ({commitmentMonths, kmAllowance, subscriptionPriceOptions}) =>
  subscriptionPriceOptions.filter(
    option =>
      (commitmentMonths === undefined || option.totalMonths === commitmentMonths) &&
      (kmAllowance === undefined || matchesKmAllowance(option, kmAllowance))
  )

export const getSelectedOption = ({
  commitmentMonths,
  kmAllowance,
  monthlySubscriptionFee,
  subscriptionPriceOptions
}) => {
  const defaultOption =
    subscriptionPriceOptions.find(({monthlyPrice}) => monthlyPrice === monthlySubscriptionFee) ||
    subscriptionPriceOptions[0]

  if (commitmentMonths === undefined && kmAllowance === undefined) return defaultOption

  const matchingOptions = getMatchingOptions({commitmentMonths, kmAllowance, subscriptionPriceOptions})

  return matchingOptions.length ? getCheapestOption(matchingOptions) : defaultOption
}

export const getCommitmentMonthsLabel = ({commitmentMonths, i18n}) =>
  commitmentMonths === 0 ? i18n.t('COMMON.NO_COMMITMENT') : i18n.t('COMMON_N_MONTHS', commitmentMonths)

export const getKmAllowanceLabel = ({kmAllowance: {kmIncluded, kmIncludedPeriod}, i18n}) => {
  if (kmIncluded === 0) return i18n.t('COMMON.NO_LIMIT')

  const periodLiteral = KM_INCLUDED_PERIOD_LITERALS[kmIncludedPeriod]

  return periodLiteral ? `${i18n.n(kmIncluded)} ${i18n.t(periodLiteral)}` : i18n.n(kmIncluded)
}
